import { CREATE_WHATSAPP_TRIAL_MESSAGE_REQUEST, CREATE_WHATSAPP_TRIAL_MESSAGE_SUCCESS, CREATE_WHATSAPP_TRIAL_MESSAGE_FAILURE, CREATE_WHATSAPP_TRIAL_MESSAGE_RESET, } from "../../actions";
const initialState = {
    data: null,
    isLoading: false,
    error: null,
};
const CreateWhatsappTrialMessagereducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_WHATSAPP_TRIAL_MESSAGE_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null });
        case CREATE_WHATSAPP_TRIAL_MESSAGE_SUCCESS:
            return Object.assign(Object.assign({}, state), { data: action.payload, isLoading: false, error: null });
        case CREATE_WHATSAPP_TRIAL_MESSAGE_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload });
        case CREATE_WHATSAPP_TRIAL_MESSAGE_RESET:
            return Object.assign(Object.assign({}, state), { isLoading: false, data: null, error: null });
        default:
            return state;
    }
};
export default CreateWhatsappTrialMessagereducer;
